<template>
    <div class="pt30">
        <el-table
            :data="todayBannerData"
            style="width: 100%"
            empty-text="데이터가 없습니다."
        >

            <el-table-column
                class="table_no"
                type="index"
                label="#"
                width="70"
                class-name="num"
                :index="tableIndex"
            >
            </el-table-column>
            <el-table-column
                align="center"
                width=""
                :prop="'b_title'"
                label="제목"
                class-name="table_bottons"
            >
            </el-table-column>
            <el-table-column
                align="center"
                width=""
                label="노출기간"
                class-name="table_bottons"
            >
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.b_period_first }} ~ {{ scope.row.b_period_end }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                width=""
                :prop="'created_at'"
                label="등록일"
                class-name="table_bottons"
            >
            </el-table-column>
            <el-table-column
                align="center"
                width=""
                :prop="'b_hit'"
                label="클릭수"
                class-name="table_bottons"
            >
            </el-table-column>
            <el-table-column
                align="center"
                width="200"
                label="옵션"
                class-name="table_bottons"
            >
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="warning"
                        @click="$router.push(`todayBanner/${scope.row.b_idx}`)">상세
                    </el-button>
                    <el-button
                        size="mini"
                        type="danger"
                        v-if="scope.row.b_display === 1"
                        @click="setNoExposure(scope.row)">노출
                    </el-button>
                    <el-button
                        size="mini"
                        type="primary"
                        v-else
                        @click="setExposure(scope.row)">미노출
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus";

export default {
    name: "TodayBannerListDefaultLayout",
    mixins: [],
    components: {},
    inject: ['setExposureBanner', 'deleteExposureBanner'],
    provide() {
        return {}
    },
    props: {
        todayBannerData: {default: () => {}},
        paginationData: {default: {page: 1, size: 10, total: 0}},
    },
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        tableIndex(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        setExposure(row) {
            this.setExposureBanner(row)
        },
        setNoExposure(row) {
            this.deleteExposureBanner(row);
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
